// src/pages/Profile/Profile1.tsx

import { FC } from 'react';
import styles from '../../css/ProfilePage.module.css';
import { motion, Variants } from 'framer-motion';
import { ArrowLeft, Linkedin, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

// Import Founder Image
import ProfileImg1 from '../../assets/images/ProfileImage1.jpeg';

const Profile1: FC = () => {
    
    // Explicitly typed Variants to resolve TypeScript error
    const fadeInUp: Variants = {
        hidden: { opacity: 0, y: 20 },
        visible: { 
            opacity: 1, 
            y: 0, 
            transition: { duration: 0.6, ease: "easeOut" } 
        }
    };

    const staggerContainer: Variants = {
        visible: {
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    return (
        <div className={styles.profilePage}>
            
            <section className={styles.heroSection}>
                <div className={styles.gridBackground}></div>
                <div className={styles.container}>
                    
                    {/* Back Navigation */}
                    <div className={styles.backLinkWrapper}>
                        <Link to="/about" className={styles.backLink}>
                            <ArrowLeft size={16} /> Back to Leadership
                        </Link>
                    </div>

                    <div className={styles.profileHeader}>
                        
                        {/* Left: Image & Socials */}
                        <motion.div 
                            className={styles.imageColumn}
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className={styles.profileImageWrapper}>
                                <img src={ProfileImg1} alt="Atoapoma Asuama Yeboah" className={styles.profileImage} />
                            </div>
                            <div className={styles.socialRow}>
                                <a 
                                    href="https://www.linkedin.com/in/atoapoma-yeboah-asuama-3b6944158/" 
                                    target="_blank" 
                                    rel="noreferrer" 
                                    className={styles.socialBtn}
                                    aria-label="LinkedIn Profile"
                                >
                                    <Linkedin size={20} />
                                </a>
                                <a 
                                    href="mailto:atoyeboah@ota-erp.com" 
                                    className={styles.socialBtn}
                                    aria-label="Contact"
                                >
                                    <Mail size={20} />
                                </a>
                            </div>
                        </motion.div>

                        {/* Right: Biography */}
                        <motion.div 
                            className={styles.infoColumn}
                            initial="hidden"
                            animate="visible"
                            variants={staggerContainer}
                        >
                            <motion.h1 className={styles.name} variants={fadeInUp}>
                                Atoapoma Asuama Yeboah
                            </motion.h1>
                            <motion.div className={styles.title} variants={fadeInUp}>
                                Founder & CEO
                            </motion.div>

                            <motion.div className={styles.bioSection} variants={fadeInUp}>
                                <h2>Professional Overview</h2>
                                <p className={styles.bioText}>
                                    Atoapoma is the Founder of OTA TECH Inc., currently preparing for the imminent launch of the company's flagship Enterprise Resource Planning (ERP) platform, OTA ERP.
                                </p>

                                <p className={styles.bioText}>
                                    Driven by a vision to eliminate operational fragmentation, he has personally designed and engineered Version 1 of OTA ERP since 2023. This comprehensive, unified platform currently integrates over 1,000 features and tools built to deliver true operational excellence for businesses.
                                </p>
                            </motion.div>

                            <motion.div className={styles.bioSection} variants={fadeInUp}>
                                <h2>Core Expertise</h2>
                                <p className={styles.bioText}>
                                    He brings a rare combination of advanced technical acumen and rigorous financial certification:
                                </p>
                                <p className={styles.bioText}>
                                    <strong>Finance & Accounting:</strong> Qualified Chartered Accountant (ICAG) and Chartered Tax Practitioner. He is a student member of the Chartered Institute of Bankers Ghana. His expertise includes costing, management accounting, financial reporting, taxation, banking, and market securities.
                                </p>
                                <p className={styles.bioText}>
                                    <strong>Deep Technical Stack:</strong> His expertise spans Machine Learning, Data Science, Data Engineering, DevOps, Google Cloud, Python, React, and React Native. He has direct experience training advanced models for platforms including Cohere, Gemini, and OpenAI.
                                </p>
                            </motion.div>

                            <motion.div className={styles.bioSection} variants={fadeInUp}>
                                <h2>Academic Background</h2>
                                <p className={styles.bioText}>
                                    He holds an <strong>MSc in Financial Engineering</strong> (WorldQuant University), an <strong>MSc in International Business</strong>, and a degree in Finance and Economics (University of Ghana Business School). 
                                </p>
                                <p className={styles.bioText}>
                                    He is currently pursuing a <strong>PhD in Finance</strong> (University of Ghana Business School) and his third postgraduate certification in MSc in Data Science, further bridging his professional domains.
                                </p>
                            </motion.div>

                            <motion.div className={styles.bioSection} variants={fadeInUp}>
                                <h2>Experience</h2>
                                <p className={styles.bioText}>
                                    His professional experience includes key finance roles at Golden Tintona Investments, Affinity Africa, PayInc Group, Maphlix Trust Ghana Ltd, Agya Appiah Bitters, and Black Point Gh, complemented by internships with the budget division of the Ministry of Finance (Ghana) and KPMG Australia. He is also a current member of Management Business Consultants Africa (MBC).
                                </p>
                            </motion.div>

                        </motion.div>
                    </div>
                </div>
                <div className={styles.heroFade}></div>
            </section>
        </div>
    );
};

export default Profile1;